sofistik-language-nav {
  display: none;
  background-color: #f4f4f4;
  position: fixed;
  top: 0;
  right: 0;
  height: 100vh;
  width: 350px;
  z-index: 3;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);
  padding: 2rem;
  transform: translateX(100%);
  transition: transform 0.25s ease-in-out;
  overflow-y: auto;

  &:not(.hidden) {
    display: block;
  }

  &.fadein {
    transform: translateX(0);
  }

  @media screen AND (max-width: 991px) {
    display: none;
  }

  .fa-times {
    cursor: pointer;
    position: absolute;
    right: 0;
    top: 0;
    padding: 1rem;
  }

  hr {
    padding-bottom: 2rem;
    margin-top: 2rem;
  }

  .country-menu,
  .country-menu-language {
    list-style: none;
    margin: 0;
    padding: 0;

    li {
      margin: 0 0 1rem 0;
      padding: 0;
    }
  }

  .country-menu {
    > li span {
      font-weight: bold;
    }
  }

  .country-menu-language {
    margin-top: 0.5rem;
    display: flex;

    > li {
      display: inline-flex;
      align-items: self-start;
      margin-right: 0.5rem;
      padding-right: 0.5rem;
      border-right: 1px solid #ccc;
      margin-bottom: 0;

      &:last-child {
        border-right: none;
        margin-right: 0;
        padding-right: 0;
      }

      a {
        font-weight: normal;
        color: rgba(0, 0, 0, 0.7);

        &.active {
          color: #00abf5;
          text-decoration: underline;
        }
      }
    }
  }
}

.site-responsivenav-open .site-responsivenav {
  .country-menu-language-language {
    display: flex;
    justify-content: space-between;
    background-color: #fff;
    border-bottom: 1px solid #ccc;

    a {
      border-bottom: 0;
    }

    .active {
      color: rgba(0, 0, 0, 0.7);
      font-weight: bold;
    }
  }

  .country-menu {
    padding: 1rem 1rem 0 1rem;

    span {
      font-size: 1.25rem;
    }

    > li {
      margin-top: 1rem;

      &:first-child {
        margin-top: 0;
      }
    }
  }
}
